import { render, staticRenderFns } from "./suppliers-component-filters.vue?vue&type=template&id=5f47cca2"
import script from "./suppliers-component-filters.vue?vue&type=script&lang=js"
export * from "./suppliers-component-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f47cca2')) {
      api.createRecord('5f47cca2', component.options)
    } else {
      api.reload('5f47cca2', component.options)
    }
    module.hot.accept("./suppliers-component-filters.vue?vue&type=template&id=5f47cca2", function () {
      api.rerender('5f47cca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/suppliers-component-filters.vue"
export default component.exports